<div class="center-container">
  <img [src]="image" />
  <br />
  <a class="main-text"> {{ message }} </a>
  <br />
  <a class="sub-text"> {{ submessage }} </a>
</div>
